<template>
  <el-dialog
    width="60%"
    title="Добавить в отчет новые отклики"
    class="dialog--add-new-responses"
    :visible.sync="visible"
    :before-close="closeDialog"
    append-to-body
    @open="open"
  >
    <el-row :gutter="24">
      <el-col :offset="18" :span="6">
        <search-input
          placeholder="Поиск"
          @clear="clearFilter"
          @search="filteredBidsList"
          @input="onInput"
        />
      </el-col>
    </el-row>
    <responses-list
      v-if="responsesListFiltered.length"
      :responses-list="responsesListFiltered"
      :report-id="reportId"
      :bid-id="bidId"
      :type="type"
    />
    <div v-else><b>Все отклики уже были добавлены в отчет</b></div>
    <div slot="footer" class="dialog-footer">
      <div>
        <el-button type="primary" @click="closeDialog">Закрыть</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { FETCH_RESPONSES_NOT_ADDED } from '@/store/actions/reports'
import { mapGetters } from 'vuex'
import ResponsesList from '@/views/Report/Modals/AddNewResponses/ResponsesList'
import SearchInput from '@/components/Shared/SearchInput'

export default {
  name: 'AddNewResponses',
  components: {
    SearchInput,
    ResponsesList,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    reportId: {
      type: Number,
      default: null,
    },
    bidId: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters({
      responsesList: 'reports/getResponsesNotAdded',
    }),
    responsesListFiltered() {
      if (!this.search.length) {
        return this.responsesList
      }

      return this.responsesList.filter(item => {
        const arr = [
          item.date_loaded,
          item.driver.fio,
          item.auto.state_numbers,
          item.auto.state_numbers_trailer,
          item.auto.carrier_name,
        ]

        return this.forEachSearchItems(arr) && item
      })
    },
  },
  methods: {
    searchField(item) {
      return String(item).toLowerCase().includes(this.search.toLowerCase())
    },
    forEachSearchItems(items) {
      let boolean = false

      items.forEach(item => {
        if (this.searchField(item)) {
          boolean = true
        }
      })

      return boolean
    },
    closeDialog() {
      this.$emit('close')
    },
    open() {
      this.$store.dispatch(
        `reports/${FETCH_RESPONSES_NOT_ADDED}`,
        this.reportId,
      )
    },
    clearFilter() {
      this.search = ''
    },
    onInput(cur) {
      this.search = cur
    },
    filteredBidsList() {
      this.search = String(this.search).trim()
    },
  },
}
</script>

<style lang="sass">
.dialog--add-new-responses
  font-family: 'Rubik', sans-serif
  .search-input
    width: 100% !important
</style>
